(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-profile/assets/javascripts/views/pages/kyc.js') >= 0) return;  svs.modules.push('/modules/player-profile/assets/javascripts/views/pages/kyc.js');

'use strict';

svs.player_profile.views.Kyc = Marionette.View.extend({
  getTemplate() {
    if (this.getOption('isSubpage')) {
      return svs.player_profile.templates.kyc_subpage;
    }
    return svs.player_profile.templates.kyc;
  },
  templateContext() {
    return {
      viewData: {
        showSummary: this.getOption('showSummary')
      }
    };
  },
  behaviors: {
    Navigation: {
      behaviorClass: svs.player_profile.behaviors.Navigation
    }
  },
  ui: {
    containerRegion: '#containerRegion'
  },
  onAttach() {
    const targetRegion = this.ui.containerRegion;
    const overviewMode = this.getOption('showSummary');
    const kycCallback = overviewMode ? this.onOverviewClick : this.onKycComplete;
    const kycCancelCallback = this.onKycCancel;
    let loader;
    $(document.body).prop('scrollTop', 0);
    if (this.getOption('preRendered')) {
      svs.components.kyc.init(targetRegion[0], {
        context: this,
        onCancel: kycCancelCallback,
        onComplete: kycCallback,
        onError: this.onKycError,
        onInitializationError: this.onKycInitError,
        showOverview: overviewMode
      });
    } else {
      loader = new svs.ui.Loader('.js-profile-loader-container');
      loader.show(300, 'inverted');
      svs.core.module.load('/cl/components/react:kyc', null, error => {
        loader.hide();
        if (error && error.statusText === 'error') {
          svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
            actions: [{
              title: 'Ok'
            }],
            area: svs.ui.dialog.area.POPUP,
            branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
            message: [{
              text: 'Kontakta vår kundservice på 0770 - 11 11 11.'
            }],
            title: 'Vi har tyvärr tekniska problem just nu',
            type: svs.ui.dialog.type.ERROR
          }));
        } else {
          svs.components.kyc.init(targetRegion[0], {
            context: this,
            onCancel: kycCancelCallback,
            onComplete: kycCallback,
            onError: this.onKycError,
            onInitializationError: this.onKycInitError,
            showOverview: overviewMode
          });
        }
      }, false);
    }
  },
  onKycInitError() {
    this.model.set('dataError', true);
  },
  onKycError() {
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      actions: [{
        title: 'Ok'
      }],
      area: svs.ui.dialog.area.POPUP,
      branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
      message: [{
        text: 'Kontakta vår kundservice på 0770 - 11 11 11.'
      }],
      title: 'Vi har tyvärr tekniska problem just nu',
      type: svs.ui.dialog.type.ERROR
    }));
  },
  onOverviewClick() {
    svs.player_profile.router.navigate('/penningtvatt/svara', true);
  },
  kycNavigate() {
    const message = 'Dina svar har sparats';
    if (this.getOption('returnUrl')) {
      svs.core.flash('success', {
        area: 'popup',
        icon: 'checkmark-thin',
        time: svs.ui.dialog.autoClose.MEDIUM,
        title: message
      }, () => {
        window.location = this.getOption('returnUrl');
      });
    } else {
      svs.player_profile.router.navigate('/penningtvatt', true);
      svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
        actions: [{
          title: 'Ok'
        }],
        area: svs.ui.dialog.area.POPUP,
        autoClose: svs.ui.dialog.autoClose.MEDIUM,
        branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
        icon: 'checkmark-thin',
        title: message
      }));
    }
  },
  onKycComplete(kycStatus) {
    if (kycStatus) {
      this.kycNavigate();
    } else {
      svs.core.module.load('/cl/components/kyc-messages', null, () => {
        svs.components.kyc_messages.showKYCMessage(kycStatus, this.kycNavigate, this);
      });
    }
  },
  onKycCancel() {
    svs.player_profile.router.navigate('/penningtvatt', true);
  },
  onBeforeDestroy() {
    if (svs.components.kyc) {
      svs.components.kyc.destroy(this.ui.containerRegion[0]);
    }
  }
});

 })(window);